import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class PurchaseOrderReportData extends ReportData<PurchaseOrderReportData> {
    @field orderId: number;
}
